import * as React from 'react';

const ViewListIcon = ({ iconColor = 'rgba(0, 130, 252, 1)' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 2H2.66667C2.26667 2 2 2.26667 2 2.66667V12.6667C2 13.0667 2.26667 13.3333 2.66667 13.3333H13.3333C13.7333 13.3333 14 13.0667 14 12.6667V2.66667C14 2.26667 13.7333 2 13.3333 2ZM12.6667 12H3.33333V10H12.6667V12ZM12.6667 8.66667H3.33333V6.66667H12.6667V8.66667ZM12.6667 5.33333H3.33333V3.33333H12.6667V5.33333Z"
      fill={iconColor}
    />
  </svg>
);
export default ViewListIcon;
